export const ICON_ERROR = 'bds/exclamation-mark/16';
export const ICON_SUCCESS = 'bds/checkmark/16';
